module.exports = __webpack_public_path__ + "img/4.12ba659b.png";